import {
  Accordion,
  AccordionContent,
  AccordionHeader,
} from '@jouzen/ecom-components/v3/Accordion';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useDynamicConfig } from '@statsig/react-bindings';
import { useTranslations } from 'next-intl';

import Section from '@/app/components/LegacyLandingPage/components/Section';

import { NewsroomAccordionContent } from './NewsroomAccordionContent';
import { NewsroomAccordionHeader } from './NewsroomAccordionHeader';
import { NewsroomContactUs } from './NewsroomContactUs';

export interface NewsroomContentObj {
  date?: string;
  headline?: string;
  subcopy?: string;
  url?: string;
}

export const NewsroomBodySection = () => {
  const t = useTranslations();
  const articleContent = useDynamicConfig('newsroom_articles_v2').value[
    'newsroomArticles'
  ] as NewsroomContentObj[];

  return (
    <Section
      className="relative -mt-8 rounded-3xl border-t bg-sandstone-100 pt-16"
      data-cy="newsroom-body-section"
    >
      <NewsroomContactUs />
      <LayoutGrid>
        <Typography className="col-main lg:col-end-8" variant="h4" Element="h2">
          {t('press_list_title')}
        </Typography>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main', lg: 9 }}>
          <Accordion openAtIndex={1}>
            {articleContent.flatMap((item, index) => [
              <AccordionHeader key={`header-${index + 1}`}>
                <NewsroomAccordionHeader
                  date={item.date}
                  headline={item.headline}
                />
              </AccordionHeader>,
              <AccordionContent key={`content-${index + 1}`}>
                <NewsroomAccordionContent
                  subcopy={item.subcopy}
                  url={item.url}
                />
              </AccordionContent>,
            ])}
          </Accordion>
        </GridItem>
      </LayoutGrid>
    </Section>
  );
};
